import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Fingerprint2 from 'fingerprintjs2';
import util from '@/libs/util';
export default {
  init: function init() {
    return new Promise(function (resolve, reject) {
      var uniqueId = util.cookies.get('uniqueId') || false;
      if (uniqueId) {
        resolve(uniqueId);
      } else {
        Fingerprint2.get(function (components) {
          var values = components.map(function (component, index) {
            if (index === 0) {
              //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
              return component.value.replace(/\bNetType\/\w+\b/, '');
            }
            return component.value;
          });
          var murmur = Fingerprint2.x64hash128(values.join(''), 31);
          util.cookies.set('uniqueId', murmur, {
            expires: 365
          });
          resolve(murmur);
        });
      }
    });
  },
  get: function get() {
    return util.cookies.get('uniqueId') || false;
  }
};